import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { ChangeIsUpdateOperation, SetUpsertModalCandidate, ShowUpsertCandidateModal } from "../Store";
import { SetSelectedOptionByCandidateId } from "../../Project/Store";
import { SetSelectedPage } from "../../../AppMenu/Store";
import PerfectScrollbar from "react-perfect-scrollbar";
import ProfilePicture from "../../../SharedComponents/ProfilePicture";

const CreateCandidateListRow = ({ candidate, setSelectedCandidate }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const positionList = useSelector((state) => state.createPosition.positionList);

  const FindPositionNameByPositionId = (positionId) => {
    return positionList.find((position) => position.id === positionId)?.name;
  };

  const handleUpdateCandidate = () => {
    dispatch(SetUpsertModalCandidate(candidate));
    setSelectedCandidate(candidate);
    dispatch(ShowUpsertCandidateModal({ upsertCandidateModalIsShown: true }));
    dispatch(ChangeIsUpdateOperation({ isUpdateOperation: true }));
  };

  return (
    <Row className="h-100 justify-content-between mx-0 d-flex flex-nowrap">
      <Col xs="auto" className="align-content-center ps-2 ps-lg-4">
        <ProfilePicture userId={candidate.applicationUserId} profilePicFileName={candidate.profilePic} size={80} />
      </Col>
      <Col className={"my-3 max-xxl-430"}>
        <Row
          className="hover-bg-darken me-0 h-100"
          onClick={() => {
            navigate("/candidate", {
              state: {
                candidateId: candidate.candidateId,
                backUrl: "/createCandidate",
              },
            });
          }}
        >
          <Col className="align-content-center " style={{ width: 1 }}>
            {" "}
            {/*I HAVE NO IDEA WHY GIVING THIS A WIDTH MAKES IT ABLE TO SHRINK, any number works.*/}
            <Row>
              <Col xs="12" className="text-20 text-color-accent fw-semibold text-truncate" style={{ maxWidth: "100%" }}>
                {candidate.candidateName}
              </Col>
            </Row>
            <Row className="text-16 text-color-gray-light fw-medium">
              <Col xs="12" className={"text-truncate"} style={{ maxWidth: "100%" }}>
                {candidate.email}
              </Col>
            </Row>
            <Row className="text-16 text-color-gray-light fw-medium">
              <Col xs="12" className={"text-truncate "} style={{ maxWidth: "100%" }}>
                {FindPositionNameByPositionId(candidate.positionId)}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      <Col className="mt-3 overflow-hidden d-none d-xxl-block" style={{ borderColor: "#E7ECEF" }}>
        <PerfectScrollbar
          options={{ suppressScrollY: true }}
          style={{ maxWidth: "100%", overflowX: "auto", paddingBottom: "15px" }}
        >
          <div
            className="h-100"
            style={{
              display: "flex",
              gap: "25px",
              padding: "12px 0",
            }}
          >
            {candidate.tickets.map((ticket, index) => (
              <div
                key={index}
                className="h-100 px-2 py-1"
                style={{
                  borderRadius: "20px",
                  width: "210px",
                  minWidth: "210px",
                  border: "solid 2px #0077b6",
                }}
              >
                <Row className="justify-content-center h-100">
                  <Col xs="auto" className="text-center align-content-center text-16 text-color-gray-dark fw-medium">
                    <Row className="justify-content-center">{ticket.assessmentName}</Row>
                    <Row className="justify-content-center" style={{ margin: "0 -6px" }}>
                      {ticket.applications.map((application, i) => {
                        const isLast = ticket.applications.length - 1 === i;
                        return (
                          <Col
                            key={i}
                            xs="auto"
                            className="justify-content-center text-10 text-color-gray-light p-0 pe-1"
                          >
                            {application.applicationName}
                            {!isLast && ","}
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </PerfectScrollbar>
      </Col>

      <Col xs="auto" className="align-content-center pe-3  d-none d-md-block">
        <Row className="justify-content-between mx-0">
          <Col xs="auto" className="align-content-center">
            <Row className="justify-content-center">
              <Button
                className="button secondary"
                onClick={() => {
                  dispatch(SetSelectedOptionByCandidateId({ value: candidate.candidateId }));
                  navigate("/project", { state: { backUrl: "/createCandidate/" } });
                  dispatch(SetSelectedPage({ url: "/project/" }));
                }}
              >
                {t("sendAssessmentButtonLabel")}
              </Button>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CreateCandidateListRow;
